import { queryString, request } from '../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/portal/sys/announcements'

const announcementService = Object.freeze({
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  getDropdownOrganisations () {
    return request(`${url}/dropdown/organisations`)
  },
  getDropdownPlatforms () {
    return request(`${url}/dropdown/platforms`)
  },
  getDropdownTargets () {
    return request(`${url}/dropdown/targets`)
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  }
})

export default announcementService
